<div class="qr-code-form-wrapper">
  <div class="content-wrapper">
    <div class="form-fields-wrapper">
      <h1 class="title">{{ "components.qrCodes.qrCodeForm.title" | translate }}</h1>

      <form [formGroup]="qrCodeForm">
        <div class="form-field">
          <mat-form-field>
            <input
              maxlength="32"
              matInput
              formControlName="Note"
              placeholder="{{ 'components.qrCodes.qrCodeForm.placeholders.note' | translate }}"
            />
          </mat-form-field>
        </div>

        <div class="form-field">
          <mee-companies-autocomplete formControlName="CompanySlug"></mee-companies-autocomplete>
        </div>

        <div class="form-field">
          <mee-teams-autocomplete
            [isDisplayTeamIdentifier]="true"
            [companySlug]="companySlug"
            formControlName="TeamSlug"
          ></mee-teams-autocomplete>
        </div>

        <div class="form-field toggle">
          <mat-slide-toggle color="primary" formControlName="IsLocalCrs">
            {{ "sources.fields-placeholders.isUseLocalCoordinatesSystem" | translate }}
          </mat-slide-toggle>
        </div>

        <div class="coordinates-group" [ngClass]="{ 'is-local-coordinates': isLocalCrs }">
          <div class="form-field">
            <mat-form-field>
              <input
                matInput
                required
                formControlName="Latitude"
                type="number"
                placeholder="{{ isLocalCrs ? 'Y' : ('configurations-fields.Latitude' | translate) }}"
              />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-form-field>
              <input
                matInput
                required
                formControlName="Longitude"
                type="number"
                placeholder="{{ isLocalCrs ? 'X' : ('configurations-fields.Longitude' | translate) }}"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-field">
          <mat-form-field>
            <input
              matInput
              formControlName="Altitude"
              type="number"
              placeholder="{{ isLocalCrs ? 'Z' : ('configurations-fields.Elevation' | translate) }}"
            />
          </mat-form-field>
        </div>
      </form>
    </div>

    <div class="qr-code-wrapper" [ngClass]="{ generated: isQrCode }">
      <h1 class="title">{{ "components.qrCodes.qrCodeForm.QrCode" | translate }}</h1>

      <ng-container *ngIf="!qrCode; else generatedQrCode">
        <qrcode [qrdata]="defaultQrCodeData" [width]="288" [margin]="2"></qrcode>
      </ng-container>
      <ng-template #generatedQrCode>
        <div class="qr-code-image-wrapper">
          <img [src]="qrCode.QrCodeUrl" alt="qr-code" />
        </div>
      </ng-template>
      <div class="qr-code-controls">
        <button mat-icon-button disableRipple [disabled]="!isQrCode || (loadingService.isLoading$() | async)" (click)="download()">
          <mat-icon mat-icon-button>download</mat-icon>
        </button>
        <button mat-icon-button disableRipple [disabled]="!isQrCode || (loadingService.isLoading$() | async)" (click)="print()">
          <mat-icon>print</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <button class="cancel-button" [mat-dialog-close]="null" mat-button>{{ "system.cancel" | translate | uppercase }}</button>
    <button [disabled]="isGenerateDisable || (loadingService.isLoading$() | async)" class="add-button" mat-raised-button (click)="save()">
      {{ (isQrCode ? "system.save" : "system.add") | translate | uppercase }}
    </button>
  </div>
</div>
